import {ApiFacilityRoles, ApiUserRoles} from "../constants/ApiRoles";
import RulesetBase from "./rulesetBase";

/**
 * Ruleset for performing multiVillage actions on events and notices.
 *
 * @class
 * @extends {RulesetBase}
 */
class MultiVillageRuleset extends RulesetBase {
  defineRules = (
    userPermissions: string[],
    userRoles?: string[] | null
  ): void => {
    const {can} = this.abilityBuilder;
    if (userRoles !== undefined && userRoles !== null) {
      for (let role of userRoles) {
        if (
          role.toUpperCase() === ApiFacilityRoles.All.toUpperCase() ||
          role.toUpperCase() === ApiUserRoles.SuperAdmin.toUpperCase()
        ) {
          can("Create", "MultiVillage");
          can("Delete", "MultiVillage");
          can("Update", "MultiVillage");
          can("Read", "MultiVillage");
          break;
        }
      }
    }
  };
}

export default MultiVillageRuleset;
